export const saleuser= () => import('@/page/distribution/saleuser.vue')

export const income= () => import('@/page/distribution/income.vue')

export const posterlist= () => import('@/page/distribution/posterlist.vue')

export const postershare= () => import('@/page/distribution/shareposter.vue')

export const widthdraw= () => import('@/page/distribution/widthdraw.vue')

export const selectway= () => import('@/page/distribution/selectway.vue')


// WEBPACK FOOTER //
// ./src/router/distribution.js